// extracted by mini-css-extract-plugin
export default {"root":"input_root__EwliI","input":"input_input__ll206","label":"input_label__ualtr"};